import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function RulesRegulations() { 
  useEffect(() => {
    document.title = 'Rules and Regulations-  CARMEL CONVENT SCHOOL, DHARUHERA';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Academics</li>
                <li>Rules and Regulations</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Rules and Regulations</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <p><b>Dear Parents,</b></p>
               <p>The School is making every effort to provide complete safety and security to each child under our care.</p>
               <p>Some of the precautions will require your close and patient cooperation, but we are confident that as caring parents, you will partner us cheerfully in this endeavour to keep your children safe, no matter how great the inconvenience faced.</p>
               
               <p>  <b> 1.</b> Safety and security of students from the time of arrival till they leave the school  premises.</p>
               <ul className="mainlist">         
               <li> Staff is in place to attend to children coming in early. School gates will only be 	opened at 07:15 A.M. </li>
               <li> Mobiles are banned for the students. </li>
               <li> First aid is available in the school </li>
               <li> There is an attendant outside the  washrooms at all times. </li>
               <li> No vendors are allowed into the premises during school hours. Teachers to strictly adhere to the "No Meeting" policy during the school hours. </li>
               <li> Three tier system in place for a child leaving before time. Gate pass  signed by 	Principal, Entry at the  School Reception with parents signature Checked at the 	gate.</li>
               </ul>
               <p> <b> 2.</b> Dispersal:</p>
               <ul className="mainlist">
               <li> Students escorted personally by the teacher to exit points at the time of school closing. </li>
               <li> No vehicle can enter the school premises without permission. </li>
               <li> Students have been issued identity cards. </li>
               <li> Letters of authority are taken in advance if the child is picked up by someone other than 	the parent. </li>
               <li> Teachers do not leave before the departure of the buses </li>
               </ul>
               <p>  <b> 3.</b>  Safety:</p>
               <ul className="mainlist">
               <li> Police verification of all School Personnel </li>
               <li> Police verification of the teaching staff, members of the administrative block, support  staff is almost complete. </li>
               <li> All staff is hired only after thorough background check and identity verification 	through Voter card or Aadhar card etc. Police verification is also carried out for such 	staff. </li>
               <li> CCTV cameras have been installed and constant checks are made to ensure their proper 	working </li> 
               <li> Camera recordings are monitored regularly by the school authorities. </li> 
               <li> Entry into the school premises must be in compliance with security norms. </li> 
               <li> Entry of persons/vehicles is recorded at the school gates by the security agency guards. </li>
               <li> Entry not given to any vehicle without the permission proper verification. </li>
               <li> Entry to the school building strictly restricted and guarded. </li>
               <li> Efficient communication system in place between the school reception and the school 	gate guards in duty. </li>
               <li> A student will not be allowed to enter the school without wearing an I-card from April 	1 for the academic session. </li>
               </ul>
               <p><b>4. </b>  Proper built boundary walls and infrastructure.</p>
               <ul className="mainlist">
               <li> The school is adequately gated and secured with the help of a grilled boundary wall </li>
               <li> CCTV cameras are in place and repair of the same are carried out at regular intervals. </li>
               <li> School is regularly checked for safety of the building and the certification for the same 	is in place.</li>
               </ul>
               <p><b>5. </b>  Restrictions regarding the usage of toilets.</p>
               <ul className="mainlist">
               <li> Washrooms renovated and updated with modern amenities have been provided for the 	students at every floor of the school building. Notices have been put for the usage of 	these only by the students. </li>
               <li> Separate toilets have been provided for the teaching staff, administrative staff members, 	and support staff. </li> 
               <li> Sensitization about the safety and security of children </li>
               </ul>
               <p>We continue to strive for the Safety and Happiness of our children and staff.</p>
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default RulesRegulations;
